
import React, { useState } from 'react';
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
// import Cont from './Cont';


  const About = () => {
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      message: ''
    });
      
    const [status, setStatus] = useState('');
  
    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const response = await fetch('https://formspree.io/f/xqaerklv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
  
      if (response.ok) {
        setFormData({ name: '', email: '', message: '' });
        setStatus('Message sent successfully!');
      } else {
        setStatus('Message failed to send. Please try again.');
      }
    };
  
  return (
    <div>
      <div className="">
        <img src={`${process.env.PUBLIC_URL}/images/Home-image.jpg`}className="d-block w-100" alt="..." />
      </div>

      <div className='maincontainer-third'>
        <div className='leftone-one'>
          <h3  className =" taketheroad" >Take The Road To </h3>
          <h1  className="growyourbusiness "> Grow Your Business</h1>
          <br></br><br></br>
          <h4 className='follow'> Follow Us

          </h4>
          <div className="icon-second">
            <a href="https://facebook.com/share/191tCpdMHP/?mibextid=qi2Omg" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="iconfa-second"  />
            </a>
            <a href="https://instagram.com/balajiitservices?igsh=eWg0aXE4Z21weW4=" target="_blank" rel="noopener noreferrer">
              <FaInstagram className=" iconfa-second"  />
            </a>
            <a href="https://linkedin.com/in/balajiitservices" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="iconfa-second"/>
            </a>

          </div>

        </div>
        <div className='rightone-one'>
          <h1 style={{ color: "white", fontFamily: "sans-serif" }}>Start A Conversation With Us  </h1>
          
           <div className="contact-form-container">
      <form onSubmit={handleSubmit} className="contact-form">
        <label>Name</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label>Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label>Message</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>

        <button type="submit">Send Message</button>

        {status && <p className="form-status">{status}</p>}
      </form>
     
    </div>
         
        </div>
      </div>

    </div>
  )
}

export default About; 
